<template>
  <v-container>
    <v-layout fill-height justify-center align-center wrap>
      <v-card width="500">
        <v-tabs
          v-model="tab"
          background-color="transparent"
          color="basil"
          grow
          centered
        >
          <v-tab>Sign-in</v-tab>
          <v-tab>Register</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item>
            <e-login-form />
          </v-tab-item>
          <v-tab-item>
            <e-register-form />
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-layout>
    <v-layout justify-center>
      <v-btn v-if="tab === 0" class="mt-2 text-none" text @click="tab = 1">
        Dont have an account? Sign-up!
      </v-btn>
      <v-btn v-else class="mt-2 text-none" text @click="tab = 0">
        Already have an account? Sign-in!
      </v-btn>
    </v-layout>
  </v-container>
</template>

<script>
import ELoginForm from "../components/ELoginForm";
import ERegisterForm from "../components/ERegisterForm";
import { IHaveStore } from "../mixins";
export default {
  components: {
    ELoginForm,
    ERegisterForm,
  },
  mixins: [IHaveStore],
  data() {
    return {
      tab: 0,
    };
  },
};
</script>

<style></style>
